$(".featured-products").ready(function () {
  onInitFeaturedProducts();
  onInitSwiper();
});

function updateCircleSize(windowWidth) {
  const featuredProductsWrapper = $(".featured-products");
  if (windowWidth < 768) {
    featuredProductsWrapper.css({
      "--circle-width": `${windowWidth + 20}px`,
      "--prev-deg": "-45deg",
      "--current-deg-for-prev": "-360deg",
      "--current-deg-for-next": "0deg",
      "--next-deg": "-315deg",
      "--rest-deg": "-180deg",
    });
  }
  if (windowWidth >= 768) {
    featuredProductsWrapper.css({
      "--circle-width": "600px",
      "--prev-deg": "-90deg",
      "--current-deg-for-prev": "-360deg",
      "--current-deg-for-next": "0deg",
      "--next-deg": "-270deg",
      "--rest-deg": "-180deg",
    });
  }
}

function onInitFeaturedProducts() {
  updateCircleSize($(window).width());
  $(window).on("resize", function () {
    updateCircleSize($(this).width());
  });
  showActiveBlock($(".featured-products__scroll-list").children().first());
}

function onInitProductSliders() {
  const $current = $(".swiper-circular-content .active");
  const $next = $current.next();
  const $prev = $current.prev();
  $prev.css({
    transform:
      "translate(-50%, -50%) rotate(var(--prev-deg)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--prev-deg) * -1))",
    opacity: 1,
  });

  $next.css({
    transform:
      "translate(-50%, -50%) rotate(var(--next-deg)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--next-deg) * -1))",
    opacity: 1,
  });
}

function onPrev() {
  const $current = $(".swiper-circular-content .active");
  const $prev = $current.prev();
  if (!$prev.length) return;

  const $next = $current.next();
  const $beforePrev = $prev.prev();

  $current.css("transition", "none");

  $current.css(
    "transform",
    "translate(-50%, -50%) rotate(var(--current-deg-for-prev)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--current-deg-for-prev) * -1))"
  );

  $current.removeClass("active");
  $prev.addClass("active");

  const activeProductId = $prev.attr("data-productid");
  showProductContent(activeProductId);

  setTimeout(() => {
    $current.css("transition", "transform 0.6s linear");

    $current.css({
      transform:
        "translate(-50%, -50%) rotate(var(--next-deg)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--next-deg) * -1))",
      opacity: 1,
    });

    $prev.css({
      transform:
        "translate(-50%, -50%) rotate(var(--current-deg-for-next)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--current-deg-for-next) * -1))",
      opacity: 1,
    });
    $next.css({
      transform:
        "translate(-50%, -50%) rotate(var(--rest-deg)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--rest-deg) * -1))",
      opacity: 0,
    });

    if ($beforePrev.length)
      $beforePrev.css({
        transform:
          "translate(-50%, -50%) rotate(var(--prev-deg)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--prev-deg) * -1))",
        opacity: 1,
      });
  });
}

function onNext() {
  const $current = $(".swiper-circular-content .active");
  const $next = $current.next();

  if (!$next.length) return;
  const $prev = $current.prev();
  const $afterNext = $next.next();

  $current.css("transition", "none");
  $current.css(
    "transform",
    "translate(-50%, -50%) rotate(var(--current-deg-for-next)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--current-deg-for-next) * -1))"
  );

  $current.removeClass("active");
  $next.addClass("active");

  const activeProductId = $next.attr("data-productid");
  showProductContent(activeProductId);

  setTimeout(() => {
    $prev.css({
      transform:
        "translate(-50%, -50%) rotate(var(--rest-deg)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--rest-deg) * -1))",
      opacity: 0,
      // opacity: 1,
      transition: "0.6s linear",
    });
    $current.css({
      transform:
        "translate(-50%, -50%) rotate(var(--prev-deg)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--prev-deg) * -1))",
      opacity: 1,
      transition: "0.6s linear",
    });
    $next.css({
      transform:
        "translate(-50%, -50%) rotate(var(--current-deg-for-prev)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--current-deg-for-prev) * -1))",
      opacity: 1,
      transition: "0.6s linear",
    });

    if ($afterNext.length)
      $afterNext.css({
        transform:
          "translate(-50%, -50%) rotate(var(--next-deg)) translate(calc(var(--circle-width) / 2)) rotate(calc(var(--next-deg) * -1))",
        opacity: 1,
        transition: "0.6s linear",
      });
  });
}

function showProductContent(productId) {
  if (!productId) return;
  const activeElementDetails = $(`#product-slider__details-${productId}`);
  activeElementDetails.siblings().hide();
  activeElementDetails.show();
}

function onInitSwiper() {
  var swiper = new Swiper(
    ".featured-products-section .collection-range__swiper",
    {
      slidesPerView: 3,
      spaceBetween: 30,
      freeMode: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
      activeIndex: 2,
      breakpoints: {
        0: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 32,
        },
      },
    }
  );
}

function showActiveBlock(activeScroll) {
  $(".featured-products__scroll-list .active")?.removeClass("active");
  activeScroll.addClass("active");
  const firstBlockId = featuredProductsBlocks[0].blockId;
  const activeBlockId =
    featuredProductsBlocks.length === 1
      ? firstBlockId
      : activeScroll?.attr("data-blockid");

  const activeBlockData = featuredProductsBlocks.find(
    (item) => item.blockId === activeBlockId
  );
  const htmlContent = generateHtmlContent(activeBlockData);
  $(".block-slide-wrapper").html(htmlContent);

  onInitProductSliders();
  updateColorScheme(activeBlockData);
}

function onPrevBlock() {
  const activeScroll = $(".featured-products__scroll-list .active");
  const prevScroll = activeScroll.prev();
  if (!prevScroll.length) return;
  showActiveBlock(prevScroll);
}

function onNextBlock() {
  const activeScroll = $(".featured-products__scroll-list .active");
  const nextScroll = activeScroll.next();
  if (!nextScroll.length) return;
  showActiveBlock(nextScroll);
}

function updateColorScheme(block) {
  const sectionWrapper = $(".featured-products-section");
  sectionWrapper.css({
    "--title-color": block.colorScheme.text,
    "--bg-color-top": block.colorScheme.background,
    "--bg-color-bottom": block.colorScheme.background_second,
    "--button-outline-color": block.colorScheme.secondary_button_label,
  });
}

function generateHtmlContent(block) {
  return `
    <div
      data-blockid="${block.blockId}"
      id="block-slide-${block.blockId}"
      class="block-slide-item"
    >
      <div class="products-content">
        <div class="products__images">
          <div class="swiper-circular">
            <div class="swiper-circular-wrapper">
              <div class="circles">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="swiper-circular-content">
                ${block.products
                  .map(
                    (product, index) => `
                    <div
                      data-productid="${product.id}"
                      id="product-slide-${product.id}"
                      class="product-slide-item ${
                        (block.products.length > 1 && index === 1) ||
                        (block.products.length === 1 && index === 0)
                          ? "active"
                          : ""
                      }"
                    >
                      <div>
                        <img
                          src="${product.featured_image}"
                          alt="${product.title}"
                        >
                      </div>
                    </div>
                  `
                  )
                  .join("")}
              </div>
                ${
                  block.products.length >= 2
                    ? `<div class="circular-actions">
                        <button id="circular-prev-btn" onclick="onPrev()">
                          <svg xmlns="http://www.w3.org/2000/svg" width="53" height="30" viewBox="0 0 53 30" fill="none">
                            <path d="M2 28L26.5 2L51 28" stroke="var(--button-outline-color)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                        <button id="circular-next-btn" onclick="onNext()">
                          <svg xmlns="http://www.w3.org/2000/svg" width="53" height="30" viewBox="0 0 53 30" fill="none">
                            <path d="M2 28L26.5 2L51 28" stroke="var(--button-outline-color)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </div>`
                    : ""
                }
            </div>
          </div>
        </div>
        <div class="product-slider__bg"></div>
        <div class="product-slider__details">
          ${block.products
            .map(
              (product, index) => `
              <div
                class="product-slider__details__content"
                id="product-slider__details-${product.id}"
                data-blockid="${product.id}"
                style="display: ${index != 0 ? "none" : "block"}"
              >
                <div>
                  <h3 class="product-slider__details-title">${
                    product.title
                  }</h3>
                </div>
                <a
                  href="${
                    block.buttonLink
                      ? block.buttonLink
                      : `/products/${product.handle}`
                  }"
                  class="product-slider__details-btn"
                  href="#"
                >
                  ${block.buttonLabel}
                </a>
              </div>  
            `
            )
            .join("")}
        </div>
      </div>
    </div>
`;
}
